module.exports = __webpack_public_path__ + "static/media/whatsapp.6bd5812f.svg";